import React from 'react';
import { Badge } from 'antd';

type Type = 'Beta' | 'Alpha' | false;
const ReleaseVersion = ({
  type,
  children,
  style,
}: {
  type?: Type;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  const LabelContainer = type ? Badge.Ribbon : React.Fragment;
  return (
    <LabelContainer text={type} style={style}>
      {children}
    </LabelContainer>
  );
};

export default ReleaseVersion;
